import styled from 'styled-components';

export const Container = styled.div`
    width: 200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    padding-top: 10px;
    position: absolute;
    top: 150px;
    right: 0;
    bottom: 0;
    z-index: 4;
    background-color: #111;

    &.active {
        top: 0;
    }
`;

export const Label = styled.div`
    text-transform: uppercase;
    font-size: 10px;
    color: #999;
    padding: 5px 10px 0;
`;

export const Input = styled.input.attrs(() => ({
    type: 'text'
}))`
    height: 25px;
    color: #999;
    border: 1px solid #555;
    padding: 0 5px;
    margin: 0 10px 10px;
    background-color: transparent;
    min-width: 20px;
    width: auto;
`;

export const Select = styled.select`
    height: 25px;
    color: #999;
    border: 1px solid #555;
    padding: 0;
    margin: 0 10px 10px;
    background-color: transparent;
    min-width: 20px;
    width: auto;
    background-color: #111;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;

    ${Label} {
        flex: 1;
    }

    ${Input} {
        flex: 1;
    }

    ${Select} {
        flex: 1;
    }
`;

export const ButtonRow = styled.div`
    margin-top: 10px;
    padding: 0 10px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
`;